import { OnInit } from '@angular/core';
import { EnvService } from '../env.service';
var PageNotFoundComponent = /** @class */ (function () {
    function PageNotFoundComponent(env) {
        this.env = env;
        this.pageNotFoundMessage = this.env.pageNotFoundMessage;
        this.pageNotFoundHeader = this.env.pageNotFoundHeader;
    }
    PageNotFoundComponent.prototype.ngOnInit = function () {
    };
    return PageNotFoundComponent;
}());
export { PageNotFoundComponent };
